import { Link, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { SignInForm } from '@/components/auth/sign-in-form';
import { safeInternalPath } from '@/lib/safe-redirect';
import { trpc } from '@/lib/trpc/client';

export const Route = createFileRoute('/_auth/sign-in')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    const redirect = safeInternalPath(search.redirect);
    return redirect ? { redirect } : {};
  },
  component: SignInPage,
});

function SignInPage(): React.ReactElement {
  const { data: providers } = trpc.auth.oauthProviders.useQuery();
  const { redirect } = Route.useSearch();
  return (
    <section className="border-border bg-card shadow-diffusion rounded-2xl border p-8">
      <h1 className="font-display text-center text-2xl tracking-tight">Se connecter</h1>
      <p className="text-muted-foreground mt-2 text-center text-sm">
        Accédez à votre espace Devizy.
      </p>
      <div className="mt-8">
        <SignInForm
          oauthGoogleEnabled={providers?.google ?? false}
          oauthLinkedinEnabled={providers?.linkedin ?? false}
          redirectTo={redirect}
        />
      </div>
      <p className="text-muted-foreground mt-6 text-center text-sm">
        Pas encore de compte ?{' '}
        <Link to="/sign-up" className="text-primary font-medium hover:underline">
          Créer un compte
        </Link>
      </p>
    </section>
  );
}
